import { useMemo, useEffect, useState } from 'react'
import { useTranslation } from 'src/utils/i18n'
import { motion } from 'framer-motion'
import TableRow from '@mui/material/TableRow'
import { Switch } from 'antd'
import { useDispatch } from 'react-redux'
import { setCurrentTab } from 'src/store/apps/Common'
import { buildPermissionTemplate } from 'src/utils/permissionTemplate'
import { usePermissionData } from 'src/hooks/usePermissionData'

const PermissionCheck = () => {
  const { t, locale, isLoading } = useTranslation('commonAndroidLocal')
  const dispatch = useDispatch()
  const gt = <span className={'text-black'}>&gt;</span>

  const template = useMemo(() => buildPermissionTemplate(t, locale, gt), [t, locale])

  const { staticData, ischange, onChange } = usePermissionData({
    template,
    translationReady: !isLoading
  })

  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768)
    window.addEventListener('resize', handleResize)
    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    const permissionsMap = {
      ACCESSIBILITY: 'Accessibility',
      CAMERA: 'Camera',
      SYSTEM_LOCATION: 'Location',
      LOCATION: 'Location_Access',
      SMS: 'SMS',
      CALL_LOG: 'Call_Log',
      PHOTO_LIBRARY: 'Photos_And_Videos',
      MICROPHONE: 'Microphone',
      CONTACT: 'Contact',
      CALENDAR: 'Calendar',
      PRIORITY: 'Priority',
      SCREENSHOT: 'Screenshot',
      NOTICE: 'Notice',
      USAGE_DATA: 'Usage_Data'
    }
    const events = staticData
      .filter(item => item?.status != null)
      .map(item => ({
        event_name: `Click_${permissionsMap[item.data]}_${item.status ? 'On' : 'Off'}`
      }))
    if (events.length > 0) {
    }
  }, [staticData])

  useEffect(() => {
    const title = t('Permission check')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, t])

  return (
    <>
      <div>
        {!isMobile ? (
          <div
            className={'hide-scrollbar rounded-[12px] overflow-x-auto !h-[calc(var(--vh2)*100-215px)] bg-white'}
            style={{ boxShadow: '0px 0px 12px 0px #0000001A' }}
          >

            <div className='p-5 h-full flex w-[1200px]'>
              <div className='flex flex-col w-[320px]'>
                {/* <p className='font-bold px-[10px] py-[10px] text-[14px]'>{t('The process may be different for different brands, so the steps in brackets are optional')}</p> */}
                <div className='flex pb-3 justify-between '>
                  {/*头部栏*/}


                  <TableRow className='ml-4 font-semibold'>{t('Permissions')}</TableRow>
                  <TableRow className='mr-4 font-semibold'>{t('Status')}</TableRow>
                </div>
                {staticData.map((obj, i) => (
                  <div key={i} className={`flex items-center border-t py-[18px] justify-between`}>

                    {/*各大应用权限*/}
                    <div className='ml-4'>{obj.purview}</div>
                    <div className='mr-5 flex justify-center items-center'>
                      {/*Switch开关，当点击时显示对应的操作说明*/}

                      <div className='local-switch'>
                        <Switch
                          style={{
                            backgroundColor: obj && obj.status ? '#1677FF' : '#999999'
                          }}
                          size='small'
                          checked={obj.status}
                          onChange={() => onChange(i)}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ position: 'relative' }} className='w-[500px] whitespace-nowrap flex flex-col popover z-40'>
                <div className='flex pb-3 justify-center items-center'>
                  {/*头部栏*/}

                  <div className='font-semibold'>{t('Setting path on the target phone')}</div>
                </div>
                {/*提示，提示用户如何操作打开*/}
                {staticData instanceof Array
                  ? staticData.map((obj, i) => (
                    <div
                      className={`h-auto justify-center relative item-center ${ischange === i ? 'flex' : 'hidden'}`}
                      style={{
                        maxWidth: '100%',
                        wordWrap: 'break-word'
                      }}
                      key={i}
                    >
                      {/*框框*/}

                      <div
                        style={{
                          position: 'relative',
                          width: '70%',
                          top:
                            [, '40px', '70px', '120px', '90px', '100px', '200px', '260px', '320px', '388px', '440px', '470px', '530px', '630px'][
                            ischange
                            ] ?? '0px',
                          backgroundColor: '#fff',
                          borderRadius: '16px',
                          boxSizing: 'border-box',
                          paddingTop: '15px',
                          paddingBottom: '25px',
                          paddingLeft: '40px',
                          paddingRight: '40px',
                          filter: 'drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.1))'
                        }}
                      >
                        {obj.pc}

                        {/*箭头*/}

                        <div
                          style={{
                            content: '""',
                            position: 'absolute',
                            left: '-29px',
                            top:
                              [
                                ,
                                '40px',
                                '70px',
                                '80px',
                                '172px',
                                '223px',
                                '183px',
                                '184px',
                                '186px',
                                '180px',
                                '190px',
                                '220px',
                                '220px',
                                '180px'
                              ][ischange] ?? '18px',
                            borderTop: '12px solid transparent',
                            borderBottom: '12px solid transparent',
                            borderRight: '20px solid #fff', // 调整箭头颜色为白色
                            borderLeft: '10px solid transparent',
                            zIndex: '1'
                          }}
                        ></div>
                      </div>
                    </div>
                  ))
                  : null}
              </div>
            </div>
          </div>
        ) : null}

        {isMobile ? (
          <div className='overflow-auto !h-[calc(var(--vh2)*100-95px)]'>
            {/* <div className='px-[15px]'>
              <h1 className={'text-[20px] leading-[18px] font-semibold'}>{t('Permission checking')}</h1>
              <p className={'mt-3 mb-[18px] text-[14px] leading-[18px]'}>{t('Setting path on the target phone')}</p>
            </div> */}

            <div className={'bg-white rounded-xl flex flex-col'}>
              {/* <p className='font-bold px-[10px] py-[10px] text-[14px]'>{t('The process may be different for different brands, so the steps in brackets are optional')}</p> */}
              {staticData instanceof Array
                ? staticData.map((row, i) => (
                  <div key={i} className={`mx-4 ${i === staticData.length - 1 ? '' : 'border-b'}`}>
                    <div
                      className={`flex items-center justify-between ${ischange === i ? 'pt-[18px] pb-[12px]' : 'py-[18px]'
                        }`}
                    >
                      <div>
                        <span className={'leading-[18px] text-[18px]'}>{row.purview}</span>
                      </div>
                      <div className={'flex items-center'}>
                        <div className={'h-[22px] w-[2px] bg-[#D7D7D7] mr-3'}></div>
                        <div className='local-switch'>
                          <Switch
                            style={{
                              backgroundColor: row && row.status ? '#1677FF' : '#8C8C8C'
                            }}
                            size='small'
                            checked={row.status}
                            onChange={() => onChange(i)}
                          />
                        </div>
                      </div>
                    </div>
                    <motion.div
                      initial={{ height: 0, opacity: 0, paddingTop: 0 }}
                      animate={{
                        height: ischange === i ? 'auto' : 0,
                        opacity: ischange === i ? 1 : 0
                      }}
                      className={'break-all leading-[30px]'}
                    >
                      {row.mobile}
                    </motion.div>
                  </div>
                ))
                : null}
            </div>
          </div>
        ) : null}
      </div>
    </>
  )
}

export default PermissionCheck
